<template>
  <div
    class="LoadingButton"
    @click="$emit('click')">
    <IconButton :icon="loading ? 'loading' : icon">
      <slot />
    </IconButton>
  </div>
</template>

<script>
import IconButton from "./IconButton";
export default {
  components: { IconButton },
  data: function () {
    return {};
  },

  props: {
    icon: {
      type: String,
      default: "send",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {},

  methods: {},

  computed: {},

  filters: {},
};
</script>

<style lang="scss" scoped>
.LoadingButton {
}
</style>
